import useMount from '@src/utils/hooks/use-mount';
import { observable, computed } from 'mobx';
import Video from '@src/components/video';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { useEffect } from 'react';
import Toast from '@src/business-components/common-message';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
const pageLocalesData = getPageLocalesData();

class ArmedIntroductionStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  // 武器轮播图
  weaponSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: false,
      spaceBetween: 0,
      effect: 'fade',
      autoplay: false,
      allowTouchMove: false
    }
  });

  // 机甲主体store
  @observable mechaStore;

  @observable isActive = false;
  @observable currentIndex = 0;
  // 机甲武装视频播放状态
  @observable weaponVideoPlayState = false;

  // 机甲武装信息
  @computed
  get weaponMsg() {
    return this.mechaStore?.mechaInfoMsg?.weapon;
  }

  clickTab(index) {
    this.currentIndex = index;
    this.weaponSwiper.onChange(index);
  }

  // 当前视频
  @computed
  get videoUrl() {
    return this.weaponMsg?.[this.currentIndex]?.video_url;
  }

  // 当前视频封面
  @computed
  get videoCover() {
    return this.weaponMsg?.[this.currentIndex]?.video_cover;
  }

  // 当前武器类型
  @computed
  get weaponType() {
    return this.weaponMsg?.[this.currentIndex]?.weapon_typt;
  }

  videoOpen() {
    if (this.videoUrl) {
      Video.append({
        src: this.videoUrl,
        onCloseCallback: () => {
          this.videoPlayState = false;
        }
      });
    } else {
      Toast.info(`${pageLocalesData.global.comming_soon}`);
    }
  }

  use() {
    useMount(() => { });
    useEffect(
      () => {
        this.currentIndex = 0;
      },
      [this.mechaStore?.mechaInfoMsg]
    );
  }
}

export default ArmedIntroductionStore;
